// extracted by mini-css-extract-plugin
export default {"subscriptionsBox":"bJZfUOFLxqYCJj5GdUCc"};